import { apiClient } from './apiClient';

export interface CPEMetricsOverview {
  totalCPEs: number;
  totalPower: number;
  averagePower: number;
  maxPower: number;
  minPower: number;
  waldevarProjects: number;
  waldevarProjectsPower: number;
  contactedCPEs: number;
  overdueNextActions: number;
  omContracted: number;
  omContractedPower: number;
  cpesWithImages: number;
  recentCPEs: number;
}

export interface CPEMetricsData {
  overview: CPEMetricsOverview;
  byPlantType: Record<string, number>;
  powerByPlantType: Record<string, number>;
  byCPEStatus: Record<string, number>;
  powerByCPEStatus: Record<string, number>;
  byCommercialStatus: Record<string, number>;
  byInternalPositioning: {
    go: number;
    no_go: number;
    not_set: number;
  };
  byEnergizationYear: Record<number, number>;
  powerByEnergizationYear: Record<number, number>;
  topAccountManagers: Array<{ name: string; count: number }>;
}

export interface CPEMetricsResponse {
  success: boolean;
  data: CPEMetricsData;
}

class MetricsService {
  private api = apiClient;

  async getCPEMetrics(): Promise<CPEMetricsData> {
    const response = await this.api.get<CPEMetricsResponse>('/metrics/cpes');
    return response.data.data;
  }
}

export const metricsService = new MetricsService();

